import { render, staticRenderFns } from "./modalApproveCompany.vue?vue&type=template&id=46ccd1c9&scoped=true"
import script from "./modalApproveCompany.vue?vue&type=script&lang=js"
export * from "./modalApproveCompany.vue?vue&type=script&lang=js"
import style0 from "./modalApproveCompany.vue?vue&type=style&index=0&id=46ccd1c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ccd1c9",
  null
  
)

export default component.exports